import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import OrderConfirmation from '../components/OrderConfirmation';
import useListenSize from '../hooks/useListenSize';
import getCustomerDetails from '../helpers/getCustomerDetails';
import { segmentEvent } from '../helpers/sendEvent';

const toCents = amount => Math.round((Number(amount) || 0) * 100);

const toConfirmationItems = item => {
  const quantity = Number(item.quantity) || 1;
  const product = {
    id: item.id,
    name: item.description,
    sku: item.sku || item.makeModel,
    price: (toCents(item.price) * quantity) / 100,
    quantity,
  };
  if (!Number(item.warranty?.price)) {
    return [product];
  }
  return [
    product,
    {
      id: `${item.id}-warranty`,
      name: `Warranty: ${item.warranty.name}`,
      sku: item.warranty.sku,
      price: (toCents(item.warranty.price) * quantity) / 100,
      quantity,
    },
  ];
};

function OrderCompleted() {
  const store = useSelector(state => ({
    checkout: state.loanInfo?.checkout,
    inStoreCart: state.loanInfo?.inStoreCart,
    newUserDetails: state.personal?.newUserDetails,
    firstName: state.personal?.firstName,
    phoneWithMask: state.contact?.phoneWithMask,
  }));
  useListenSize();

  const { checkout = {} } = store;
  const customer = getCustomerDetails(store);
  const items = (store.inStoreCart || []).reduce((all, item) => all.concat(toConfirmationItems(item)), []);

  useEffect(() => {
    segmentEvent('page', 'Instore Order Completed', {
      cart_total: checkout.cart_total,
      due_today: checkout.due_today,
      cart_item_count: (store.inStoreCart || []).length,
    });
  }, []);

  return (
    <div className="k-content-wrapper">
      <OrderConfirmation
        customer={customer.name ? customer : null}
        items={items}
        totals={[
          { label: 'Leasable Total', amount: checkout.leasable_cash_price },
          { label: 'Total', amount: checkout.cart_total, bold: true },
          { label: 'Due Today', amount: checkout.due_today, bold: true },
        ]}
      />
    </div>
  );
}

export default OrderCompleted;
